import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Uzbekistan.css";

import samarkand from "../photos/registon_night.webp";
import bukhara from "../photos/buxoro1.webp";
import khiva from "../photos/xiva2.webp";
import tashkent from "../photos/toshkent2.webp";
import shahrisabz from "../photos/uzb_shahr_oqsaroy1.webp";
import vodiyImg from "../photos/uzb_farg_xonsaroy2.webp";
import termiz from "../photos/uzb_term_hakim3.webp";
import qoraqalpoq from "../photos/uzb_qq_savitskiy2.webp";


const regions = (t) => [
    {
        name: t("uzbekistan.regions.samarkand.name"),
        key: "samarkand",
        img: samarkand,
        desc: t("uzbekistan.regions.samarkand.desc")
    },
    {
        name: t("uzbekistan.regions.bukhara.name"),
        key: "bukhara",
        img: bukhara,
        desc: t("uzbekistan.regions.bukhara.desc")
    },
    {
        name: t("uzbekistan.regions.khiva.name"),
        key: "khiva",
        img: khiva,
        desc: t("uzbekistan.regions.khiva.desc")
    },
    {
        name: t("uzbekistan.regions.tashkent.name"),
        key: "tashkent",
        img: tashkent,
        desc: t("uzbekistan.regions.tashkent.desc")
    },
    {
        name: t("uzbekistan.regions.shahrisabz.name"),
        key: "shahrisabz",
        img: shahrisabz,
        desc: t("uzbekistan.regions.shahrisabz.desc")
    },
    {
        name: t("uzbekistan.regions.vodiy.name"),
        key: "vodiy",
        img: vodiyImg,
        desc: t("uzbekistan.regions.vodiy.desc")
    },
    {
        name: t("uzbekistan.regions.termiz.name"),
        key: "termiz",
        img: termiz,
        desc: t("uzbekistan.regions.termiz.desc")
    },
    {
        name: t("uzbekistan.regions.qoraqalpoq.name"),
        key: "qoraqalpoq",  
        img: qoraqalpoq,
        desc: t("uzbekistan.regions.qoraqalpoq.desc")
    },

];

const Uzbekistan = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="uzbekistan-page">

            <h1 className="title">{t("uzbekistan.title")}</h1>
            <p className="subtitle">{t("uzbekistan.subtitle")}</p>

            <div className="grid">
                {regions(t).map((r, i) => (
                    <div
                        key={i}
                        className="card"
                        onClick={() => navigate(`/uzbekistan/${r.key}`)}
                    >
                        <img src={r.img} alt={r.name} />
                        <div className="card-content">
                            <h2>{r.name}</h2>
                            <p>{r.desc}</p>
                            <button>{t("uzbekistan.button")}</button>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default Uzbekistan;